<template>
  <oil-form v-if="loading"
            title="Создать Счет фактуру"
            :items="invoice"
            :createForm="!invoice.Id"
            :keys="keys"
            :formCallback="formCallback"
            @SupplierId="changeSupplier"
            @ContractId="changeContract"
  >
    <template v-slot:File="{input}">
      <v-file-input :disabled="!input.isEdit" @change="file" dense outlined :label="label"/>
    </template>
    <template v-slot:Download='{input}'>
      <v-tooltip bottom>
        <template v-slot:activator='{ on, attrs }'>
          <v-btn style='box-shadow: none;color: #00b24f;background-color: transparent' :disabled='!input.isEdit'
                 @click='dow(invoice)'
                 v-bind='attrs'
                 v-on='on'
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>
        <span>Скачать</span>
      </v-tooltip>
    </template>
  </oil-form>

</template>

<script>
import keys from './setting/coming_invoice.json'
import {coreApi} from "~/services/core";
import { fileService } from '~/services/FileNextNumberService'

export default {
  props: {
    id: String
  },
  components: {
    OilForm: () => import('@/components/helper/oil.form'),
  },
  data: () => ({
    keys,
    invoice: {
      Supplier: {},
      Contract: {},
      File: {},
      Attachment: {},
      Number: '',
      ContractNumber: '',
      StartDate: '',
      Status: '',
      Comment: ''
    },
    loading: false,
    suppliers: [],
    contracts: [],
    label: 'Загрузить файл'
  }),
  async created() {
    const suppliers = await coreApi.get('suppler')
    this.suppliers = suppliers.data || []

    if (this.id) {
      const response = await coreApi.get(`coming-invoice?id=${this.id}`)
      this.label = response.data?.Attachment?.Name || 'загрузить файл'
      this.invoice = response.data
      this.changeSupplier(this.invoice.Supplier)
    }
    this.loading = true
  },
  computed:{
    storeType() {
      return this.id ? coreApi.put : coreApi.post
    },
    message(){
      return this.id ? 'счет фактура удачно изменен' : 'счет фактура удачно создан'
    }
  },
  methods: {
    async file(file) {
      const fileId = await fileService.generateId()
      const res = await fileService.upload(fileId.data.Id, file)
      this.invoice.Attachment = res.data
    },
    async formCallback(data, input,form,func) {
      input.isEdit = false
      const response = await this.storeType('coming-invoice', data)
      if (!response.data) {
        input.isEdit = true
        return
      }

      func(this.message)

      this.invoice = response.data
    },
    changeSupplier(supplier) {
      if (!supplier) return
      this.invoice.Supplier = {...supplier}
      this.contracts = supplier.Contracts
    },
    changeContract(contract) {
      if (!contract) return
      this.invoice.Contract = {...contract}
    }
  },
  watch: {
    suppliers(suppliers) {
      this.keys["Supplier.Id"].attrs.items = suppliers
    },
    contracts(contracts) {
      this.keys["Contract.Id"].attrs.items = contracts
    }
  }
}
</script>